import { useLocation } from 'react-router-dom';

export default function useCurrentHref() {
  const { pathname, search } = useLocation();
  return `${pathname}${search}`;
}
